import {
  createRouter,
  RouteRecordRaw,
  RouteLocationNormalized,
  NavigationGuardNext,
  createWebHistory,
} from 'vue-router';

import { getEnv } from '@/env';

import { authRouter } from './authRouter';
import { baseStaticUrl } from '@/utils/const';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home/index.vue'),
    meta: {
      auth: true, // 权限凭证
    },
    children: [
      {
        path: 'data-center',
        name: 'dataCenter',
        component: () =>
          import(/* webpackChunkName: "dataCenter" */ '@/views/DataCenter/index.vue'),
        meta: {},
      },

      {
        path: 'employee-management',
        name: 'employeeManagement',
        component: () =>
          import(
            /* webpackChunkName: "employeeManagement" */ '@/views/EmployeeManagement/index.vue'
          ),
        meta: {},
      },

      {
        path: 'role-management',
        name: 'roleManagement',
        component: () =>
          import(/* webpackChunkName: "roleManagement" */ '@/views/RoleManagement/index.vue'),
        meta: {},
      },

      {
        path: 'customer-group-service-management',
        name: 'customerGroupServiceManagement',
        component: () =>
          import(
            /* webpackChunkName: "customerGroupServiceManagement" */ '@/views/CustomerGroupService/index.vue'
          ),
        meta: {},
      },

      {
        path: 'customer-service-management',
        name: 'customerServiceManagement',
        component: () =>
          import(
            /* webpackChunkName: "customerServiceManagement" */ '@/views/CustomerService/index.vue'
          ),
        meta: {},
      },

      {
        path: 'session-config',
        name: 'sessionConfig',
        component: () =>
          import(/* webpackChunkName: "sessionConfig" */ '@/views/SessionConfig/index.vue'),
        meta: {},
      },
      // H5接入
      {
        path: 'customer-access',
        name: 'h5Access',
        component: () =>
          import(/* webpackChunkName: "h5Access" */ '@/views/AccessManagement/H5Access.vue'),
        meta: {},
      },
      // 客服坐席
      {
        path: 'customerservice-session',
        name: 'CustomerserviceSession',
        component: () =>
          import(
            /* webpackChunkName: "CustomerserviceSession" */ '@/views/CustomerserviceSession/index.vue'
          ),
        meta: {},
      },
      // 问答知识库
      {
        path: 'question-answers',
        name: 'QuestionAnswers',
        component: () =>
          import(
            /* webpackChunkName: "QuestionAnswers" */ '@/views/KnowledgebaseManagement/QuestionAnswers.vue'
          ),
        meta: {},
      },
      // 客服常用语
      {
        path: 'common-phrases',
        name: 'CommonPhrases',
        component: () =>
          import(
            /* webpackChunkName: "CommonPhrases" */ '@/views/KnowledgebaseManagement/CommonPhrases.vue'
          ),
        meta: {},
      },
      // 客户列表
      {
        path: 'customer-list',
        name: 'CustomerList',
        component: () =>
          import(/* webpackChunkName: "CustomerList" */ '@/views/CustomerList/index.vue'),
        meta: {},
      },
      // 客户详情
      {
        path: 'customer-detail',
        name: 'customerDetail',
        component: () =>
          import(
            /* webpackChunkName: "customerDetail" */ '@/views/CustomerList/components/CustomerDetail.vue'
          ),
        meta: {},
      },

      {
        path: 'robot',
        name: 'robot',
        component: () =>
          import(/* webpackChunkName: "robot" */ '@/views/RobotManagement/Robot.vue'),
        meta: {},
      },
    ],
    redirect: '/data-center',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login/index.vue'),
    meta: {},
  },
];

const env = getEnv(import.meta.env.MODE);
const router = createRouter({
  history: createWebHistory(env.routerBase),
  routes,
});

router.beforeEach(
  async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    if (to.meta.auth) {
      // 权限校验拦截
      const resp = await authRouter(to, from, next);
      if (resp) {
        return;
      }
    }
    if (['sessionConfig', 'robot'].includes(from.name as any) && to.path !== from.path) {
      const confirmed = window.confirm($t('common_4'));
      if (confirmed) {
        next();
      } else {
        next(false);
      }
    }
    if (to.matched.length === 0) {
      //如果未匹配到路由
      from.path ? next({ path: from.path }) : next('/'); //如果上级也未匹配到路由则跳转主页面，如果上级能匹配到则转上级路由
    } else {
      next(); //如果匹配到正确跳转
    }
  }
);

router.onError((error, to) => {
  if (error.message.includes('Failed to fetch dynamically imported module')) {
    // const url = baseStaticUrl.replace(/\/$/, '');
    // window.location.href = String(url + to.fullPath);
  }
});

export default router;
